import React from 'react'
import { Input, InputProps } from '@rebass/forms'
import { useSTheme } from 'styles/theme'
import { ga4_inputChanged } from 'utils/ga4'

type Props = InputProps & { alwaysDatePicker?: boolean; passwordVisibility?: boolean }

const SInput = React.forwardRef((props: Props, ref) => {
    const { sx = {}, ...otherProps } = props
    const theme = useSTheme()

    let additionalProps = {}
    if (props.alwaysDatePicker) {
        additionalProps = {
            '::-webkit-calendar-picker-indicator': {
                background: 'transparent',
                bottom: '0',
                color: 'transparent',
                cursor: 'pointer',
                height: 'auto',
                left: '0',
                position: 'absolute',
                right: '0',
                top: '0',
                width: 'auto',
            },
        }
    }

    return (
        <Input
            sx={{
                bg: 'inputBg',
                borderRadius: '8px',
                px: '13px',
                py: '13px',
                fontSize: 3,
                border: 'none',
                boxSizing: 'border-box',
                borderWidth: 1,
                borderStyle: 'solid',
                borderColor: 'inputBorder',
                height: 50,
                textAlignLast: 'left',
                whiteSpace: 'pre-line',
                lineHeight: '140%',
                fontWeight: '400',
                opacity: '80%',

                '::placeholder': {
                    textAlignLast: 'left',
                    whiteSpace: 'pre-line',
                    lineHeight: '140%',
                    fontWeight: '400',
                    fontSize: '14px',
                    color: theme.colors.grayLabelPlaceholder,
                },
                '&:hover': {
                    borderColor: 'inputBorder',
                },

                '&:focus': {
                    boxShadow: `0px 0px 0px 3px ${theme.colors.inputShadow}`,
                    borderColor: theme.colors.secondaryColor,
                    borderWidth: 1,
                },
                outline: 'none',

                ...additionalProps,
                ...sx,
            }}
            ref={ref}
            {...otherProps}
            onChange={(e) => {
                if (props.maxLength && props.type === 'number') {
                    if (e.target.value.length >= props.maxLength) {
                        e.target.value = e.target.value.slice(0, props.maxLength)
                    }
                }
                ga4_inputChanged(props.name, e.target.value.length === 1)
                if (props.onChange) {
                    props.onChange(e)
                }
            }}
        />
    )
})

SInput.displayName = 'SInput'

export default SInput
